import { Outlet } from "react-router";

export const PortalPage = () => {
  return <Outlet />;
};
